module.exports = __webpack_public_path__ + "img/zoom_out.146c0954.svg";